const MAX_ROOMS = 5;

type RoomRanges = Record<string, number>;
export const getGeneratedDescriptionRooms = (roomsRanges: RoomRanges) => {
    return Object.entries(roomsRanges).reduce<RoomRanges>((acc, [rooms, amount]) => {
        if (parseInt(rooms) < MAX_ROOMS) {
            acc[rooms] = amount;
        } else {
            acc[MAX_ROOMS.toString()] = (acc[MAX_ROOMS.toString()] || 0) + amount;
        }

        return acc;
    }, {});
};
const MAX_ROOMS = 5;

type RoomRanges = Record<string, number>;
export const getGeneratedDescriptionRooms = (roomsRanges: RoomRanges) => {
    return Object.entries(roomsRanges).reduce<RoomRanges>((acc, [rooms, amount]) => {
        if (parseInt(rooms) < MAX_ROOMS) {
            acc[rooms] = amount;
        } else {
            acc[MAX_ROOMS.toString()] = (acc[MAX_ROOMS.toString()] || 0) + amount;
        }

        return acc;
    }, {});
};
